import React, { useState } from "react";
import estadosymunicipios from "../utils/estados-municipios.json";
import "../styles/Rutas.css";

const Rutas = () => {
  const [estadoOrigen, setEstadoOrigen] = useState("");
  const [ciudadOrigen, setCiudadOrigen] = useState("");
  const [estadoDestino, setEstadoDestino] = useState("");
  const [ciudadDestino, setCiudadDestino] = useState("");

  const handleBuscarRuta = () => {
    alert(`Ruta de ${ciudadOrigen}, ${estadoOrigen} a ${ciudadDestino}, ${estadoDestino}`);
  };

  return (
    <div className="Container">
      <div className="Title-Banner">
        <h2>Zonas Económicas Especiales</h2>
        <h3>Coatzacoalcos</h3>
      </div>

      <div className="Title">
        <h1>Tu ruta logística</h1>
      </div>

      <div className="Text">
        <p>
          Selecciona el estado y ciudad de origen, posteriormente el estado y ciudad de destino, finalmente elige el tipo de vehículo en el
          que transportarás tu mercancía.
        </p>
        <p>
          Si deseas añadir puntos intermedios en tu ruta, deberás seleccionar una ciudad distinta a la ciudad de origen y destino.
        </p>
      </div>

      <div className="Route-Selector">
        <label>
          <i className="fas fa-map-marker-alt"></i> Estado origen:
          <select value={estadoOrigen} onChange={e => {
            setEstadoOrigen(e.target.value);
            setCiudadOrigen("");
          }}>
            <option value="">Seleccione</option>
            {Object.keys(estadosymunicipios).map(estado => (
              <option key={estado} value={estado}>{estado}</option>
            ))}
          </select>
        </label>

        <label>
          <i className="fas fa-map-marker-alt"></i> Estado destino:
          <select value={estadoDestino} onChange={e => {
            setEstadoDestino(e.target.value);
            setCiudadDestino("");
          }}>
            <option value="">Seleccione</option>
            {Object.keys(estadosymunicipios).map(estado => (
              <option key={estado} value={estado}>{estado}</option>
            ))}
          </select>
        </label>
      </div>

      <div className="Route-Selector">
        <label>
          <i className="fas fa-city"></i> Ciudad origen:
          <select value={ciudadOrigen} onChange={e => setCiudadOrigen(e.target.value)}>
            <option value="">Seleccione</option>
            {(estadosymunicipios[estadoOrigen] || []).map(ciudad => (
              <option key={ciudad} value={ciudad}>{ciudad}</option>
            ))}
          </select>
        </label>

        <label>
          <i className="fas fa-city"></i> Ciudad destino:
          <select value={ciudadDestino} onChange={e => setCiudadDestino(e.target.value)}>
            <option value="">Seleccione</option>
            {(estadosymunicipios[estadoDestino] || []).map(ciudad => (
              <option key={ciudad} value={ciudad}>{ciudad}</option>
            ))}
          </select>
        </label>

        <button onClick={handleBuscarRuta}>Buscar ruta</button>
      </div>
    </div>
  );
};

export default Rutas;

